import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (id) => `${API}/media/file/${id}`;
export const assetUrl = (id) => `${API}/assets/${id}`;

export async function uploadAsset(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/assets", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return assetUrl(data.id);
}

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
